import { Skeleton } from '@mui/material';

export const AccountMenuButtonSkeleton = () => {
  return <Skeleton width={170} height={40} variant="rounded" />;
};
